import React from "react";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { TIndexTypeGroupPresentationModel } from "../../presenter/model/IndexTypeGroupPresentationModel";

interface IndexTypeGroupSimpleGridProps {
  translate: any;
  referenceLoader?: boolean;
  indexTypeGroups: TIndexTypeGroupPresentationModel[];
}
const IndexTypeGroupSimpleGrid: React.FC<IndexTypeGroupSimpleGridProps> = ({
  translate,
  referenceLoader,
  indexTypeGroups
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.index_type_categories"
  });
  const columns = builder.buildColumns(
    "code",
    "name",
    "description",

    {
      name: "valid",
      dataKey: "valid",
      sortable: false,
      align: "center",
      render: (record) => <TickBox value={record.valid} />
    }
  );

  return (
    <DataGrid
      recordStartEditingBehavior="row"
      title={translate("editors.index_type_groups.title")}
      columns={columns}
      translate={translate}
      dataSource={indexTypeGroups || []}
      allowCreate={false}
      allowUpdate={false}
      loading={referenceLoader}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"id"}
      createActionPosition={"topRight"}
    />
  );
};
export default IndexTypeGroupSimpleGrid;
